import React from "react";
import "./precos.css";

function Precos() {
  const whatsapp = "5563992494311";

  function enviarAvaliacao(e) {
    e.preventDefault();

    const form = e.target;

    const mensagem = `
📌 *Avaliação gratuita com diagnóstico técnico*

👤 Nome: ${form.nome.value}
📧 Contato: ${form.contato.value}
📄 Tipo de trabalho: ${form.tipo.value}
📊 Etapa atual: ${form.etapa.value}

📝 Dificuldade:
${form.descricao.value}
    `;

    const url = `https://wa.me/${whatsapp}?text=${encodeURIComponent(
      mensagem
    )}`;

    window.open(url, "_blank");
  }

  return (
    <section id="preco">
      <div className="container">

        {/* TÍTULO */}
        <div className="row text-center mb-5">
          <div className="titulo">
            <h1>Planos e Valores</h1>
            <p>
              Valores de referência para serviços de apoio, correção e
              orientação acadêmica em Engenharia Civil.
            </p>
          </div>
        </div>

        {/* CARDS */}
        <div className="row text-center">

          {/* SERVIÇO 1 */}
          <div className="col-lg-3 mb-4">
            <div className="card h-100">
              <div className="card-header">
                <h1>Revisão Técnica</h1>
              </div>
              <div className="card-body">
                <h2>R$ 300 – R$ 600</h2>
                <p>Análise estrutural do TCC</p>
                <p>Metodologia e coerência técnica</p>
                <p>Adequação ao tema proposto</p>

                <a
                  href={`https://wa.me/${whatsapp}?text=Olá,%20gostaria%20de%20informações%20sobre%20Revisão%20Técnica%20de%20TCC.`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-lg btn-primary"
                >
                  Solicitar análise
                </a>
              </div>
            </div>
          </div>

          {/* SERVIÇO 2 */}
          <div className="col-lg-3 mb-4">
            <div className="card h-100">
              <div className="card-header">
                <h1>Revisão ABNT</h1>
              </div>
              <div className="card-body">
                <h2>R$ 150 – R$ 300</h2>
                <p>Formatação completa ABNT</p>
                <p>Referências e citações</p>
                <p>Padronização do documento</p>

                <a
                  href={`https://wa.me/${whatsapp}?text=Olá,%20gostaria%20de%20informações%20sobre%20Revisão%20ABNT%20para%20TCC.`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-lg btn-outline-primary"
                >
                  Solicitar correção
                </a>
              </div>
            </div>
          </div>

          {/* SERVIÇO 3 */}
          <div className="col-lg-3 mb-4">
            <div className="card h-100">
              <div className="card-header">
                <h1>Cálculos Estruturais</h1>
              </div>
              <div className="card-body">
                <h2>R$ 250 – R$ 800</h2>
                <p>Apoio em dimensionamentos</p>
                <p>Conferência de cálculos</p>
                <p>Orientação técnica aplicada</p>

                <a
                  href={`https://wa.me/${whatsapp}?text=Olá,%20gostaria%20de%20informações%20sobre%20apoio%20em%20Cálculos%20Estruturais.`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-lg btn-primary"
                >
                  Falar com especialista
                </a>
              </div>
            </div>
          </div>

          {/* SERVIÇO 4 */}
          <div className="col-lg-3 mb-4">
            <div className="card h-100">
              <div className="card-header">
                <h1>Orientação Individual</h1>
              </div>
              <div className="card-body">
                <h2>R$ 150 / hora</h2>
                <p>Atendimento por chamada</p>
                <p>Esclarecimento de dúvidas</p>
                <p>Direcionamento técnico</p>

                <a
                  href={`https://wa.me/${whatsapp}?text=Olá,%20gostaria%20de%20agendar%20uma%20orientação%20individual%20em%20Engenharia%20Civil.`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-lg btn-outline-primary"
                >
                  Agendar call
                </a>
              </div>
            </div>
          </div>

          {/* SERVIÇO 5 — AVALIAÇÃO GRATUITA */}
          <div className="col-lg-3 mb-4">
            <div className="card h-100 border-success">
              <div className="card-header bg-success text-white">
                <h1>Avaliação Gratuita</h1>
              </div>
              <div className="card-body">
                <h2>Diagnóstico Técnico</h2>
                <p>✔️ Avaliação sem compromisso</p>
                <p>✔️ Não realizamos trabalhos prontos</p>
                <p>✔️ Retorno em até 24h úteis</p>

                <button
                  className="btn btn-lg btn-success mt-2"
                  data-bs-toggle="modal"
                  data-bs-target="#avaliacaoModal"
                >
                  Solicitar avaliação
                </button>
              </div>
            </div>
          </div>

        </div>

        {/* OBSERVAÇÃO */}
        <div className="row mt-4">
          <div className="col text-center">
            <p className="text-muted" style={{ fontSize: "0.9rem" }}>
              * Os valores podem variar conforme complexidade, prazo e volume do
              material analisado. Não realizamos elaboração integral de trabalhos acadêmicos.
            </p>
          </div>
        </div>

      </div>

      {/* MODAL */}
      <div
        className="modal fade"
        id="avaliacaoModal"
        tabIndex="-1"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">
                Avaliação gratuita com diagnóstico técnico
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
              ></button>
            </div>

            <div className="modal-body">
              <form onSubmit={enviarAvaliacao}>
                <div className="row g-3">

                  <div className="col-md-6">
                    <input
                      name="nome"
                      className="form-control"
                      placeholder="Nome"
                      required
                    />
                  </div>

                  <div className="col-md-6">
                    <input
                      name="contato"
                      className="form-control"
                      placeholder="E-mail ou WhatsApp"
                      required
                    />
                  </div>

                  <div className="col-md-6">
                    <select name="tipo" className="form-select" required>
                      <option value="">Tipo de trabalho</option>
                      <option>TCC</option>
                      <option>Artigo</option>
                      <option>Projeto</option>
                    </select>
                  </div>

                  <div className="col-md-6">
                    <select name="etapa" className="form-select" required>
                      <option value="">Etapa atual</option>
                      <option>Início</option>
                      <option>Meio</option>
                      <option>Final</option>
                    </select>
                  </div>

                  <div className="col-12">
                    <textarea
                      name="descricao"
                      className="form-control"
                      rows="4"
                      placeholder="Descreva sua dificuldade"
                      required
                    ></textarea>
                  </div>

                  <div className="col-12 text-end">
                    <button type="submit" className="btn btn-success">
                      Enviar pelo WhatsApp
                    </button>
                  </div>

                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

    </section>
  );
}

export default Precos;
